import ContactFormMeta, { IContactFormMeta } from './ContactFormMeta';

const SecondContactFormMeta: IContactFormMeta =  { ...JSON.parse(JSON.stringify(ContactFormMeta))} as IContactFormMeta;

SecondContactFormMeta.firstName.name = 'contact2FirstName';
SecondContactFormMeta.lastName.name = 'contact2LastName';
SecondContactFormMeta.position.name = 'contact2Position';
SecondContactFormMeta.phone.name = 'contact2Phone';
SecondContactFormMeta.email.name = 'contact2Email';

export default SecondContactFormMeta;